// Cómo se compra y cómo se gasta cada insumo.
//
// No son la misma unidad, y ese es todo el problema:
//
//   la SAL    se compra por bultos de 33 kilos y se gasta en kilos
//   el CUAJO  se compra por frascos y se mide en CENTÍMETROS de la regla del
//             frasco: 4 cm por cada 10 litros de leche
//
// Hasta ahora el programa pedía la cantidad en la unidad de gasto y quien
// compraba tenía que multiplicar de cabeza. Multiplicar de cabeza a las cinco
// de la mañana es como entra un cero de más al inventario.

// Ojo con `Number(null)`, que es 0 y no NaN: sin este primer renglón, una
// cantidad sin llenar se convertía en un cero perfectamente válido y entraba al
// inventario como si alguien hubiera contado y no hubiera nada.
const num = (x) => {
  if (x === null || x === undefined || x === '') return null;
  const n = Number(x);
  return Number.isFinite(n) ? n : null;
};

// Un bulto de sal son 33 kilos. Es el dato del cliente, no un estándar.
export const KILOS_POR_BULTO = 33;

// Cuatro centímetros de cuajo por cada diez litros de leche. También es su
// medida: en otra planta el frasco es otro y la regla marca distinto.
export const CM_DE_CUAJO = 4;
export const LITROS_POR_MEDIDA = 10;

// Cuánto cuajo lleva esta cuajada, en centímetros.
//
// Es una SUGERENCIA, no una imposición: se propone en el formulario y quien
// cuaja la corrige si ese día usó más. Imponerla haría que el inventario
// dijera lo que debió gastarse y no lo que se gastó, y entonces la existencia
// deja de servir para pedir a tiempo.
export function cuajoSugerido(litros) {
  const L = num(litros);
  if (!L || L <= 0) return null;
  // Un decimal: la regla del frasco no da para más.
  return Math.round((L / LITROS_POR_MEDIDA) * CM_DE_CUAJO * 10) / 10;
}

// De la unidad en que se compra a la unidad en que se gasta.
//
//   cantidad   3 (bultos)
//   equivale   33 (kilos por bulto)
//   →          99 (kilos)
//
// Sin equivalencia se devuelve la cantidad tal cual: es un insumo que se compra
// y se gasta en la misma unidad, que es el caso normal.
export function aUnidadDeGasto(cantidad, equivale) {
  const c = num(cantidad);
  if (c === null) return null;
  const e = num(equivale);
  if (!e || e <= 0) return c;
  return Math.round(c * e * 1000) / 1000;
}

// El camino de vuelta: cuántos bultos son estos kilos. Para poder decir «le
// quedan 2,5 bultos» en vez de «le quedan 82,5 kilos», que es como se piensa
// al ir a comprar.
export function enUnidadDeCompra(cantidad, equivale) {
  const c = num(cantidad);
  if (c === null) return null;
  const e = num(equivale);
  if (!e || e <= 0) return null;
  return Math.round((c / e) * 100) / 100;
}

// Cómo se dice una existencia cuando el insumo se compra por bultos.
//
// Las dos unidades juntas, porque las dos se usan: los kilos para saber si
// alcanza la cuajada de mañana, los bultos para saber cuántos pedir.
export function decirExistencia(insumo) {
  if (!insumo) return '';
  const cant = num(insumo.existencia) || 0;
  const base = `${Math.round(cant * 100) / 100} ${insumo.unidad || ''}`.trim();
  const bultos = enUnidadDeCompra(cant, insumo.equivale);
  if (bultos === null || !insumo.unidad_compra) return base;
  return `${base} · ${bultos} ${insumo.unidad_compra}${bultos === 1 ? '' : 's'}`;
}
